import React from 'react'
import ReactDOM from 'react-dom'
// IMPORTING BOOTSTRAP CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import WebRoutes from './Routes/WebRoutes'
import './i18n'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
// import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient()
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <WebRoutes />
  </QueryClientProvider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
